import "./assets/css/boxicons.css";
import "./assets/css/core.css";
import "./assets/css/demo.css";
import "./assets/css/theme-default.css";
import "./assets/css/auth.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/style.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import Layout from "./components/common/Layout";
import PrivateRoute from "./components/common/PrivateRoute";
import PrivateAdminRoute from "./components/common/PrivateAdminRoute";
import PrivatePermissionRoute from "./components/common/PrivatePermissionRoute";
import LoginPage from "./pages/Login/LoginPage";
import PrivacyPolicyPage from "./pages/Others/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/Others/TermsAndConditionsPage";
import ApplicationProvider from "./context/ApplicationProvider";
import UsersList from "./pages/Users/UsersList";
import UserCreate from "./pages/Users/UserCreate";
import UserEdit from "./pages/Users/UserEdit";
import NewsList from "./pages/News/Newslist";
import NewsCreate from "./pages/News/NewsCreate";
import NewsEdit from "./pages/News/NewsEdit";
import CountryAdminUserList from "./pages/Admin/CountryAdmin/CountryAdminList";
import CountryAdminUserCreate from "./pages/Admin/CountryAdmin/CreateCountryAdmin";
import CountryAdminUserEdit from "./pages/Admin/CountryAdmin/EditCountryAdmin";
import StateAdminUserList from "./pages/Admin/StateAdmin/StateAdminList";
import StateAdminUserCreate from "./pages/Admin/StateAdmin/CreateStateAdmin";
import StateAdminUserEdit from "./pages/Admin/StateAdmin/EditStateAdmin";
import RegionAdminUserList from "./pages/Admin/RegionAdmin/RegionAdminList";
import RegionAdminUserCreate from "./pages/Admin/RegionAdmin/CreateRegionAdmin";
import RegionAdminUserEdit from "./pages/Admin/RegionAdmin/EditRegionAdmin";
import ChapterAdminUserList from "./pages/Admin/ChapterAdmin/ChapterAdminList";
import ChapterAdminUserCreate from "./pages/Admin/ChapterAdmin/CreateChapterAdmin";
import ChapterAdminUserEdit from "./pages/Admin/ChapterAdmin/EditChapterAdmin";
import CountrysList from "./pages/Countrys/CountrysList";
import CreateCountry from "./pages/Countrys/CreateCountry";
import EditCountry from "./pages/Countrys/EditCountry";
import StatesList from "./pages/States/StatesList";
import CreateState from "./pages/States/CreateState";
import EditState from "./pages/States/EditState";
import RegionsList from "./pages/Regions/RegionsList";
import CreateRegion from "./pages/Regions/CreateRegion";
import EditRegion from "./pages/Regions/EditRegion";
import ChaptersList from "./pages/Chapters/ChaptersList";
import CreateChapter from "./pages/Chapters/CreateChapter";
import EditChapter from "./pages/Chapters/EditChapter";
import UserRolesList from "./pages/UserRoles/UserRolesList";
import CreateUserRole from "./pages/UserRoles/CreateUserRole";
import EditUserRole from "./pages/UserRoles/EditUserRole";
import CategoryList from "./pages/Category/CategoryList";
import CreateCategory from "./pages/Category/CreateCategory";
import EditCategory from "./pages/Category/EditCategory";
import BloodgroupList from "./pages/Bloodgroup/BloodgroupList";
import CreateBloodgroup from "./pages/Bloodgroup/CreateBloodgroup";
import EditBloodgroup from "./pages/Bloodgroup/EditBloodgroup";
import TimersList from "./pages/Timers/TimersList";
import CreateTimer from "./pages/Timers/CreateTimer";
import EditTimer from "./pages/Timers/EditTimer";
import EditTimerAccess from "./pages/Timers/EditTimerAccess";
import RolesList from "./pages/Roles/RolesList";
import CreateRole from "./pages/Roles/CreateRole";
import EditRole from "./pages/Roles/EditRole";
import TyfcbList from "./pages/Tyfcb/TyfcbList";
import WeeklyMeetingsList from "./pages/MeetingSchedules/WeeklyMeetingsList";
import SchedulesList from "./pages/MeetingSchedules/SchedulesList";
import OnetoOneList from "./pages/OnetoOne/OnetoOneList";
import ReferralsList from "./pages/Referrals/ReferralsList";
import VisitorsList from "./pages/Visitors/VisitorsList";
import ChangePassword from "./pages/Login/ChangePassword";
import Settings from "./pages/Login/Settings";
import Logout from "./pages/Login/Logout";
import MonthlyFeesList from "./pages/MeetingSchedules/MonthlyFeesList";
import EventsList from "./pages/Events/EventsList";
import CreateEvent from "./pages/Events/CreateEvent";
import EditEvent from "./pages/Events/EditEvent";

import TyfcbReportsList from "./pages/Reports/TyfcbReportsList";
import BizgivenReportsList from "./pages/Reports/BizgivenReportsList";
import OnetoOneReportsList from "./pages/Reports/OnetoOneReportsList";
import ReferralsReportsList from "./pages/Reports/ReferralsReportsList";
import VisitorsReportsList from "./pages/Reports/VisitorsReportsList";
import FeesReportsList from "./pages/Reports/FeesReportsList";
import OverallReportsList from "./pages/Reports/OverallReportsList";
import AttendanceReportsList from "./pages/Reports/AttendanceReportsList";
import PointsReportsList from "./pages/Reports/PointsReportsList";
import MembershipExpiryRenewalReportsList from "./pages/Reports/MembershipExpiryRenewalReportsList";

import TestimonialsList from "./pages/Testimonials/TestimonialsList";
import PointsSystem from "./pages/Points/PointsSystem";

function App() {
  return (
    <>
      <ApplicationProvider>
        <ToastContainer autoClose={800} />
        <Router>
          <Routes>
            <Route element={<PrivateRoute />}>
              <Route path="/" element={<Layout />}>
                <Route
                  element={<PrivatePermissionRoute permission="dashboard-view" />}
                >
                  <Route index path="/" element={<Dashboard />} />
                  <Route index path="/home" element={<Dashboard />} />
                  <Route index path="/dashboard" element={<Dashboard />} />
                </Route>
                <Route path="/change-password" element={<ChangePassword />} />
                <Route
                  element={
                    <PrivatePermissionRoute permission="settings-list" />
                  }
                >
                  <Route path="/settings" element={<Settings />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="members-list" />}
                >
                  <Route path="/users" element={<UsersList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="members-create" />
                  }
                >
                  <Route path="/user/create" element={<UserCreate />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="members-edit" />}
                >
                  <Route path="/user/:id/edit" element={<UserEdit />} />
                </Route>
                 <Route
                    element={
                      <PrivatePermissionRoute permission="user-roles-list" />
                    }
                  >
                    <Route path="/user-roles" element={<UserRolesList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="user-roles-create" />
                    }
                  >
                    <Route
                      path="/create/user-role"
                      element={<CreateUserRole />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="user-roles-edit" />
                    }
                  >
                    <Route
                      path="/user-role/:id/edit"
                      element={<EditUserRole />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="business-category-list" />
                    }
                  >
                    <Route path="/category" element={<CategoryList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="business-category-create" />
                    }
                  >
                    <Route
                      path="/create/category"
                      element={<CreateCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="business-category-edit" />
                    }
                  >
                    <Route
                      path="/category/:id/edit"
                      element={<EditCategory />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="blood-groups-list" />
                    }
                  >
                    <Route path="/blood-groups" element={<BloodgroupList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="blood-groups-create" />
                    }
                  >
                    <Route
                      path="/create/blood-group"
                      element={<CreateBloodgroup />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="blood-groups-edit" />
                    }
                  >
                    <Route
                      path="/blood-group/:id/edit"
                      element={<EditBloodgroup />}
                    />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="timers-list" />}
                  >
                    <Route path="/timers" element={<TimersList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="timers-create" />
                    }
                  >
                    <Route path="/create/timer" element={<CreateTimer />} />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="timers-edit" />}
                  >
                    <Route path="/timer/:id/edit" element={<EditTimer />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="timer-access-list" />
                    }
                  >
                    <Route path="/timer-access" element={<EditTimerAccess />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="reports-reward-points" />
                    }
                  >
                    <Route path="/points-system" element={<PointsSystem />} />
                  </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1]} />}>
                  <Route
                    element={<PrivatePermissionRoute permission="roles-list" />}
                  >
                    <Route path="/roles" element={<RolesList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="roles-create" />
                    }
                  >
                    <Route path="/create/role" element={<CreateRole />} />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="roles-edit" />}
                  >
                    <Route path="/role/:id/edit" element={<EditRole />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="countries-list" />
                    }
                  >
                    <Route path="/countries" element={<CountrysList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="countries-create" />
                    }
                  >
                    <Route path="/create/country" element={<CreateCountry />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="countries-edit" />
                    }
                  >
                    <Route path="/country/:id/edit" element={<EditCountry />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-admins-list" />
                    }
                  >
                    <Route
                      path="/country-admin-users"
                      element={<CountryAdminUserList />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-admins-create" />
                    }
                  >
                    <Route
                      path="/country-admin-user/create"
                      element={<CountryAdminUserCreate />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="country-admins-edit" />
                    }
                  >
                    <Route
                      path="/country-admin-user/:id/edit"
                      element={<CountryAdminUserEdit />}
                    />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 6]} />}>
                  <Route
                    element={<PrivatePermissionRoute permission="states-list" />}
                  >
                    <Route path="/states" element={<StatesList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="states-create" />
                    }
                  >
                    <Route path="/create/state" element={<CreateState />} />
                  </Route>
                  <Route
                    element={<PrivatePermissionRoute permission="states-edit" />}
                  >
                    <Route path="/state/:id/edit" element={<EditState />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="state-admins-list" />
                    }
                  >
                    <Route
                      path="/state-admin-users"
                      element={<StateAdminUserList />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="state-admins-create" />
                    }
                  >
                    <Route
                      path="/state-admin-user/create"
                      element={<StateAdminUserCreate />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="state-admins-edit" />
                    }
                  >
                    <Route
                      path="/state-admin-user/:id/edit"
                      element={<StateAdminUserEdit />}
                    />
                  </Route>
                </Route>
                <Route element={<PrivateAdminRoute allowedRoles={[1, 6, 7]} />}>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="regions-list" />
                    }
                  >
                    <Route path="/regions" element={<RegionsList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="regions-create" />
                    }
                  >
                    <Route path="/create/region" element={<CreateRegion />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="regions-edit" />
                    }
                  >
                    <Route path="/region/:id/edit" element={<EditRegion />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="region-admins-list" />
                    }
                  >
                    <Route
                      path="/region-admin-users"
                      element={<RegionAdminUserList />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="region-admins-create" />
                    }
                  >
                    <Route
                      path="/region-admin-user/create"
                      element={<RegionAdminUserCreate />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="region-admins-edit" />
                    }
                  >
                    <Route
                      path="/region-admin-user/:id/edit"
                      element={<RegionAdminUserEdit />}
                    />
                  </Route>
                </Route>
                <Route
                  element={<PrivateAdminRoute allowedRoles={[1, 6, 7, 2]} />}
                >
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapters-list" />
                    }
                  >
                    <Route path="/chapters" element={<ChaptersList />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapters-create" />
                    }
                  >
                    <Route path="/create/chapter" element={<CreateChapter />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapters-edit" />
                    }
                  >
                    <Route path="/chapter/:id/edit" element={<EditChapter />} />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-admins-list" />
                    }
                  >
                    <Route
                      path="/chapter-admin-users"
                      element={<ChapterAdminUserList />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-admins-create" />
                    }
                  >
                    <Route
                      path="/chapter-admin-user/create"
                      element={<ChapterAdminUserCreate />}
                    />
                  </Route>
                  <Route
                    element={
                      <PrivatePermissionRoute permission="chapter-admins-edit" />
                    }
                  >
                    <Route
                      path="/chapter-admin-user/:id/edit"
                      element={<ChapterAdminUserEdit />}
                    />
                  </Route>
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="tyfcbs-list" />}
                >
                  <Route path="/tyfcbs" element={<TyfcbList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="121s-list" />
                  }
                >
                  <Route path="/one-to-one" element={<OnetoOneList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="referrals-list" />
                  }
                >
                  <Route path="/referrals" element={<ReferralsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-general-list" />
                  }
                >
                  <Route
                    path="/visitors/general"
                    element={
                      <VisitorsList visitType="0" visitTypeText="General" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-chief-guest-list" />
                  }
                >
                  <Route
                    path="/visitors/chief-guest"
                    element={
                      <VisitorsList visitType="1" visitTypeText="Chief Guest" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-power-date-list" />
                  }
                >
                  <Route
                    path="/visitors/power-date"
                    element={
                      <VisitorsList visitType="2" visitTypeText="Power Date" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-inductions-list" />
                  }
                >
                  <Route
                    path="/visitors/inductions"
                    element={
                      <VisitorsList visitType="3" visitTypeText="Inductions" />
                    }
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="visitors-consumers-list" />
                  }
                >
                  <Route
                    path="/visitors/consumers"
                    element={
                      <VisitorsList visitType="4" visitTypeText="Consumers" />
                    }
                  />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="weekly-attendance-list" />}
                >
                  <Route path="/weekly-meetings" element={<WeeklyMeetingsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="weekly-attendance-list" />}
                >
                  <Route
                    path="/meeting-schedules"
                    element={<SchedulesList />}
                  />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="monthly-fees-list" />}
                >
                  <Route path="/monthly-fees" element={<MonthlyFeesList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="events-list" />}
                >
                  <Route path="/events" element={<EventsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="events-create" />
                  }
                >
                  <Route path="/create/event" element={<CreateEvent />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="events-edit" />}
                >
                  <Route path="/event/:id/edit" element={<EditEvent />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="news-list" />}
                >
                  <Route path="/news" element={<NewsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="news-create" />}
                >
                  <Route path="/news/create" element={<NewsCreate />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="news-edit" />}
                >
                  <Route path="/news/:id/edit" element={<NewsEdit />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="testimonials-list" />
                  }
                >
                  <Route path="/testimonials" element={<TestimonialsList />} />
                </Route>
                <Route
                  element={<PrivatePermissionRoute permission="reports-reward-points" />}
                >
                  <Route path="/points" element={<PointsReportsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-tyns-list" />
                  }
                >
                  <Route
                    path="/reports/tyfcbs"
                    element={<TyfcbReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-biz-given-list" />
                  }
                >
                  <Route
                    path="/reports/biz-given"
                    element={<BizgivenReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-121s-list" />
                  }
                >
                  <Route
                    path="/reports/one-to-one"
                    element={<OnetoOneReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-referrals-list" />
                  }
                >
                  <Route
                    path="/reports/referrals"
                    element={<ReferralsReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-visitors-list" />
                  }
                >
                  <Route
                    path="/reports/visitors"
                    element={<VisitorsReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-fees-list" />
                  }
                >
                  <Route path="/reports/fees" element={<FeesReportsList />} />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-attendance-list" />
                  }
                >
                  <Route
                    path="/reports/attendance"
                    element={<AttendanceReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-overall-list" />
                  }
                >
                  <Route
                    path="/reports/overall"
                    element={<OverallReportsList />}
                  />
                </Route>
                <Route
                  element={
                    <PrivatePermissionRoute permission="reports-membership-expiry-renewal-list" />
                  }
                >
                  <Route
                    path="/reports/membership-expiry-renewals"
                    element={<MembershipExpiryRenewalReportsList />}
                  />
                </Route>
                <Route path="/logout" element={<Logout />} />
              </Route>
            </Route>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route
              path="/terms-and-conditions"
              element={<TermsAndConditionsPage />}
            />
          </Routes>
        </Router>
      </ApplicationProvider>
    </>
  );
}

export default App;
